import { PAGE_NAMES } from '../../constants/page';

export const ENDPOINTS = {
    [PAGE_NAMES.SettingsAccount]: 'memberprofilesettingsviewmodel',
    [PAGE_NAMES.SettingsEmail]: 'memberemailnotificationssettingsviewmodel',
    [PAGE_NAMES.SettingsSeller]: 'membersellersettingsviewmodel',
    [PAGE_NAMES.SettingsSecurity]: 'membersecuritysettingsviewmodel',
};

export const SCROLL_ANCHORS = {
    ACCOUNT_IMAGE: '#account-image',
    ACCOUNT_PRESENTATION: '#account-presentation',
    ACCOUNT_DETAILS: '#account-details',
    ACCOUNT_PERSONAL: '#account-personal',
    AUTO_FEEDBACK: '#auto-feedback',
    MAKE_AN_OFFER: '#make-and-offer',
    SILENT_MESSAGING: '#silent-messaging',
    COMBINED_SHIPPING: '#combined-shipping',
    AUTO_CALC_PRICE_SHIPPING: '#auto-calc-price-shipping',
    COMMIT_ON_PAYMENT: '#commit-on-payment',
    AUTO_SHIPPING: '#auto-shipping',
    LISTING: '#listing',
    EMAIL_GENERAL: '#email-general',
    EMAIL_BUYING: '#email-buying',
    EMAIL_SELLING: '#email-selling',
    EMAIL_OTHER: '#email-other',
    NOTIFICATION_ACTIVE: '#notification-active',
    NOTIFICATION_BUYING: '#notification-buying',
    NOTIFICATION_SELLING: '#notification-selling',
    SECURITY_PASSWORD: '#security-password',
    SECURITY_LOGOUT: '#security-logout',
    SECURITY_BLOCKED_MEMBERS: '#security-blocked-members',
    SECURITY_DEACTIVATE: '#security-deactivate',
    LOCALIZAION_LANGUAGE_CURRENCY: '#localization-language-currency',
    LOCALIZATION_TRANSLATION_PREFERRED: '#localization-translation-preferred',
    PAYOUTS_ACCOUNT: '#payouts-account',
    PAYOUTS_SWISH: '#payouts-swish',
    PAYOUTS_INTERVAL: '#payouts-interval',
    VACATION_MODE: '#vacation-mode',
};
